import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'phdsoft-formly-file-link',
    templateUrl: './formly-file-link.component.html'
})
export class FormlyFileLinkComponent extends FieldType {

}
